var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 477,
    viewBox: "0 0 129 477",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#009645",
    d: "M-73.415.589l201.75 40.868L40.34 475.864l-201.75-40.868zM100.454 35.299L12.26 470.687M-117.705 216.722l202.73 41.066M4.817 120.447l-47.519 234.588M-69.138 105.96l148.669 30.115M-115.497 339.778l148.669 30.115"
  })));
}
export default SvgMapBackground;